import React from "react";
import styled from "styled-components";
import Navbar from "../components/Navbar";
import { useNavigate, useParams } from "react-router-dom";
import { services } from "../data";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useMediaQuery } from "@mui/material";

const Services = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:768px)");
  const { id } = useParams();
  const serviceDetails = services?.find((item) => item.id === Number(id));
  const uniqueServiceDetails = serviceDetails?.unqiueService;

  window.onpopstate = () => {
    navigate("/#videoSlider");
  };

  const handleWhatsappClick = () => {
    window.location.href = "https://wa.link/hj33t3";
  };

  const handleIconOnClick = (navLink) => {
    window.location.href = navLink;
  };

  const RenderFooterContainer = () => {
    const socialMedia = [
      {
        id: 1,
        icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Instagram_icon.png/2048px-Instagram_icon.png",
        action:
          "https://www.instagram.com/luxedesign.firm?igsh=cmFsYzF4a3BqaDdm",
      },
      {
        id: 2,
        icon: "https://www.edigitalagency.com.au/wp-content/uploads/whatsapp-logo-png-green-square.png",
        action: "https://wa.link/hj33t3",
      },
    ];

    return (
      <FooterContainer>
        <SocialContainer>
          {socialMedia.map((item) => (
            <div
              key={item.id}
              onClick={() => {
                handleIconOnClick(item.action);
              }}
            >
              <FooterImg src={item.icon} />
            </div>
          ))}
        </SocialContainer>
        <FooterTitle>LUXE INTERIOR DESIGN FIRM</FooterTitle>
        <FooterDescription>
          Design & Build | Interior Design Firms Malaysia/Singapore | Interior
          Design Companies Malaysia/Singapore | Interior Design Companies Near
          Me | Top Interior Design Companies | Best Interior Design Company
          Commercial Interior Design | Commercial Contractor Malaysia |
          Renovation Company | Home Remodeling Contractors | Id Contractors |
          Fit Out Company | Corporate Interior Design | Retails & Commercial
          Electrical Maintenance | Shopping Mall Maintenance
        </FooterDescription>
      </FooterContainer>
    );
  };

  return (
    <Container>
      <StickyHeader>
        {/* <Announcement /> */}
        <Navbar isOtherScreen={true} />
      </StickyHeader>
      {isMobile && (
        <LeftArrowIcon>
          <KeyboardBackspaceIcon
            style={{ fontSize: 24 }}
            onClick={() => {
              navigate("/#videoSlider");
            }}
          />
        </LeftArrowIcon>
      )}
      <ServiceContainer>
        <ServiceHeader>
          <ServiceImage
            src={`/img/services/${serviceDetails.serviceImg}`}
            alt={serviceDetails.title}
          />
          <ServiceTitle>{serviceDetails.title}</ServiceTitle>
          <ServiceDescription>{serviceDetails.description}</ServiceDescription>
        </ServiceHeader>

        {serviceDetails.services.map((item, index) => (
          <ContentView key={index}>
            {index % 2 === 0 ? (
              <ContentContainer>
                <LeftContainer>
                  <Title>{item.title}</Title>
                  <Text dangerouslySetInnerHTML={{ __html: item.desc }} />
                </LeftContainer>
                <RightContainer>
                  <Image src={`/img/services/${item.img}`} alt={item.title} />
                </RightContainer>
              </ContentContainer>
            ) : (
              <ContentContainer>
                <LeftContainer>
                  <Image src={`/img/services/${item.img}`} alt={item.title} />
                </LeftContainer>
                <RightContainer>
                  <Title>{item.title}</Title>
                  <Text dangerouslySetInnerHTML={{ __html: item.desc }} />
                </RightContainer>
              </ContentContainer>
            )}
          </ContentView>
        ))}

        {uniqueServiceDetails && (
          <UniqueContainer>
            {uniqueServiceDetails.img && (
              <UniqueImage
                src={`/img/services/${uniqueServiceDetails.img}`}
                alt={uniqueServiceDetails.title}
              />
            )}
            {uniqueServiceDetails.title && (
              <UniqueTitle>{uniqueServiceDetails.title}</UniqueTitle>
            )}
            <UniqueDescription
              dangerouslySetInnerHTML={{
                __html: uniqueServiceDetails.description,
              }}
            />
          </UniqueContainer>
        )}
        <RenderFooterContainer />
      </ServiceContainer>
      <WhatsappContainer onClick={handleWhatsappClick}>
        <WhatsappIcon src="/whatsappIcon.svg" />
      </WhatsappContainer>
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  overflow: hidden;
`;

const StickyHeader = styled.div`
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 3;
`;

const LeftArrowIcon = styled.div`
  position: absolute;
  left: 7px;
  top: 35px;
`;

const ServiceContainer = styled.div`
  height: 100vh;
  background-color: #f5fbfd;
  scroll-snap-type: y mandatory;
  scroll-snap-stop: inherit;
  scroll-behavior: smooth;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const ServiceHeader = styled.div`
  padding: 60px 80px 150px 80px;
  align-items: center;
  @media (max-width: 768px) {
    padding: 60px 30px 30px 30px;
  }
`;

const ServiceImage = styled.img`
  height: 300px;
  width: 100%;
  object-fit: cover;
  @media (max-width: 768px) {
    height: 150px;
  }
`;

const ServiceTitle = styled.h2`
  font-size: 54px;
  font-style: normal;
  font-family: "Kestrel";
  margin-top: 12px;
  @media (max-width: 768px) {
    font-size: 26px;
  }
`;

const ServiceDescription = styled.p`
  font-size: 20px;
  white-space: pre-wrap;
  color: #3b3b3b;
  margin-top: 5px;
  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const ContentView = styled.div`
  width: 100%;
`;

const ContentContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 0px 80px 50px 80px;
  box-sizing: border-box;
  column-gap: 20px;
  @media (max-width: 768px) {
    padding: 0px 50px 15px 20px;
    margin-top: 40px;
  }
`;

const LeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  padding: 0 20px 0 20px;
  padding-left: 10%;
  box-sizing: border-box;
  row-gap: 20px;
  @media (max-width: 768px) {
    padding-left: 5%;
    row-gap: 10px;
    padding: 0 10px 0 10px;
  }
`;

const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  padding: 0 20px 0 20px;
  padding-right: 20%;
  box-sizing: border-box;
  row-gap: 20px;
  @media (max-width: 768px) {
    padding-right: 5%;
    row-gap: 10px;
    padding: 0 10px 0 10px;
  }
`;

const Image = styled.img`
  display: flex;
  height: 470px;
  width: 350px;
  object-fit: cover;
  @media (max-width: 768px) {
    height: 250px;
    width: 130px;
  }
`;

const Title = styled.h3`
  font-size: 44px;
  font-style: normal;
  font-family: "Kestrel";
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const Text = styled.p`
  font-size: 20px;
  white-space: pre-wrap;
  color: #3b3b3b;
  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

const UniqueContainer = styled.div`
  padding: 30px 390px 80px 220px;
  align-items: center;
  @media (max-width: 768px) {
    padding: 30px 60px 30px 30px;
  }
`;

const UniqueImage = styled.img`
  height: 450px;
  width: 100%;
  object-fit: cover;
  @media (max-width: 768px) {
    height: 150px;
  }
`;

const UniqueTitle = styled.h2`
  font-size: 54px;
  font-style: normal;
  font-family: "Kestrel";
  margin-top: 12px;
  @media (max-width: 768px) {
    font-size: 26px;
  }
`;

const UniqueDescription = styled.p`
  font-size: 20px;
  white-space: pre-wrap;
  color: #3b3b3b;
  margin-top: 5px;
  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const SocialContainer = styled.div`
  display: flex;
  justify-content: center;
  column-gap: 15px;
  margin-bottom: 5px;
  cursor: pointer;
`;

const FooterImg = styled.img`
  display: flex;
  height: 35px;
  width: 35px;
  &:hover {
    opacity: 0.6;
  }
  @media (max-width: 768px) {
    height: 20px;
    width: 20px;
  }
`;

const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 130px;
  /* margin-top: 50px; */
  padding: 0 150px 0px 150px;
  justify-content: center;
  row-gap: 5px;
  background-color: lightgray;
  -webkit-tap-highlight-color: transparent;
  @media (max-width: 768px) {
    padding: 0px 20px 0px 20px;
  }
`;

const FooterTitle = styled.h4`
  font-size: 14px;
  line-height: 13px;
  text-align: center;
  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

const FooterDescription = styled.p`
  font-size: 14px;
  line-height: 15px;
  text-align: center;
  @media (max-width: 768px) {
    font-size: 7px;
    line-height: 10px;
  }
`;

const WhatsappContainer = styled.div`
  display: flex;
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 5;
  cursor: pointer;
  &:hover {
    opacity: 0.6;
    transform: scale(1.2);
  }
  @media (max-width: 768px) {
    bottom: 40px;
    right: 15px;
  }
`;

const WhatsappIcon = styled.img`
  display: flex;
  height: 50px;
  width: 50px;
  @media (max-width: 768px) {
    height: 45px;
    width: 45px;
  }
`;

export default Services;
